import { ContainerComponent, wrap } from 'AppReact';
import { RangeBlock, SecondaryTextSm300, SecondaryTextXs300 } from 'atoms';
import internalState from './internalState';
import { FlexCenterWrapper, ColumnWrapper, Mx1, BorderedCard, Mt1, Width100, TextCenterWrapper, FlexBoxWrapper, Mr2 } from 'wrappers';
import { getIsMobile } from 'utils';

const isMobile = getIsMobile();

export const definition = {
  name: 'MapLegend',
  controller: {},
  initialProps: ({ ranges, bordered, width }) => ({ ranges, bordered, width }),
  props: internalState,
  renderIf: ({ ranges }) => ranges.length > 0,
  elements: [
    {
      wrapper: FlexBoxWrapper,
      renderIf: ({ bordered }) => !bordered,
      name: 'Wrapper',
      elements: [
        {
          name: 'Range',
          isListOf: 'ranges',
          wrapper: wrap(ColumnWrapper, Mx1),
          elements: [
            {
              component: RangeBlock,
              name: 'Block',
              displayValue: ({ }) => '',
              displayState: ({ range, width }) => ({ color: range.color, width: width ?? '78px' })
            },
            {
              component: wrap(SecondaryTextSm300, Mt1),
              name: 'Text',
              displayValue: ({ range }) => range.text
            }
          ]
        },
      ]
    },
    {
      wrapper: BorderedCard,
      name: 'BorderWrapper',
      renderIf: ({ bordered }) => bordered,
      displayState: ({ }) => ({ borderRadius: '8px', background: '#FFFFFF' }),
      elements: [
        {
          wrapper: isMobile ? FlexCenterWrapper : FlexBoxWrapper,
          name: 'Wrapper',
          elements: [
            {
              name: 'Range',
              isListOf: 'ranges',
              wrapper: isMobile ? wrap(FlexCenterWrapper, Mx1) : wrap(ColumnWrapper, Mx1),
              elements: [
                {
                  component: isMobile ? wrap(RangeBlock, Mr2) : RangeBlock,
                  name: 'Block',
                  displayValue: ({ }) => '',
                  displayState: ({ range }) => ({ color: range.color, width: isMobile ? '11px' : null })
                },
                {
                  component: isMobile ? wrap(SecondaryTextXs300, TextCenterWrapper) : wrap(wrap(wrap(SecondaryTextSm300, Mt1), Width100), TextCenterWrapper),
                  name: 'Text',
                  displayValue: ({ range }) => range.text
                }
              ]
            },
          ]
        },
      ]
    }
  ]
}

export default ContainerComponent(definition);